import React from 'react'
import type { ConnectorProps as HeaderProps } from '../../connectors/Header'
import HeaderConnector from '../../connectors/Header'
import { Header } from './styles'

const Component = ({
  category,
  title,
  keyword,
}: HeaderProps): React.ReactElement<React.ComponentProps<any>, any> => {
  return (
    <Header>
      <h1>{`Results for "${title}" ${category}`}</h1>
    </Header>
  )
}

export default HeaderConnector(Component)